<template>
	<div>
		<b-card>
			<h4 class="mb-3">Registro Consultas</h4>

			<b-form-input
				v-model="search"
				placeholder="Buscar en todos los campos..."
				class="mb-3"
			/>

			<b-table
				:items="filteredRegistros"
				:fields="fields"
				:per-page="perPage"
				:current-page="currentPage"
				responsive
				bordered
				small
			>
				<template #cell(payload)="data">
					<b-button size="sm" variant="info" @click="abrirModalConJson(data.item.payload)">Ver</b-button>
				</template>
				<template #cell(data)="data">
					<b-button size="sm" variant="info" @click="abrirModalConJson(data.item.data)">Ver</b-button>
				</template>
				<template #cell(created_at)="data">
					{{ formatFecha(data.item.created_at) }}
				</template>
				<template #cell(response)="data">
					<span
						@click="abrirModalConJson(data.item.response)"
						style="cursor:pointer; color:blue; text-decoration: underline;"
					>
						{{ data.item.response.length > 150 ? data.item.response.slice(0, 150) + '...' : data.item.response }}
					</span>
				</template>
			</b-table>

			<b-pagination
				v-model="currentPage"
				:total-rows="filteredRegistros.length"
				:per-page="perPage"
				align="right"
				class="mt-2"
			></b-pagination>

			<b-modal ref="modalJson" :title="modalTitle" hide-footer size="lg">
				<pre
					style="white-space: pre-wrap; word-break: break-word; text-align: left; font-family: monospace;"
				>
{{ JSON.stringify(modalJsonData, null, 2) }}
				</pre>
			</b-modal>
		</b-card>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data() {
		return {
			registros: [],
			search: '',
			currentPage: 1,
			perPage: 25,
			modalTitle: '',
			modalJsonData: null,
			fields: [
  { key: 'id', label: 'ID', sortable: true, thStyle: { width: '4%' } },
  { key: 'origen', label: 'Origen', sortable: true, thStyle: { width: '12%' } },
  // { key: 'ruta', label: 'Ruta', sortable: true },
  { key: 'user_agent', label: 'User Agent', sortable: true, thStyle: { width: '10%' } },
  { key: 'payload', label: 'Payload', thStyle: { width: '4%' } },
  { key: 'data', label: 'Data', thStyle: { width: '4%' } },
  { key: 'response', label: 'Response', thStyle: { width: '43%' } },
  { key: 'created_at', label: 'Fecha', sortable: true, thStyle: { width: '10%' } }
]

		}
	},
	computed: {
		filteredRegistros() {
			if (!this.search) return this.registros
			const lowerSearch = this.search.toLowerCase()
			return this.registros.filter(item =>
				Object.values(item).some(
					val =>
						val &&
						val
							.toString()
							.toLowerCase()
							.includes(lowerSearch)
				)
			)
		}
	},
	methods: {
        formatFecha(fecha) {
            if (!fecha) return ''
            return moment(fecha).format('DD/MM/YYYY - HH:mm:ss')
        },
		abrirModalConJson(data) {
			this.modalTitle = 'Detalle JSON'
			try {
				if (typeof data === 'string') {
					this.modalJsonData = JSON.parse(data)
				} else {
					this.modalJsonData = data
				}
			} catch (e) {
				this.modalJsonData = 'JSON inválido o mal formateado'
			}
			this.$refs.modalJson.show()
		},
		async fetchRegistros() {
			const res = await axios.get('/api/registro_consultas')
			this.registros = res.data.regs
		}
	},
	mounted() {
		this.fetchRegistros()
	}
}
</script>
